import { AxiosError } from 'axios';

import { captureException } from '@sentry/react';
import type { WriteContractErrorType } from '@wagmi/core';

import {
  ERROR_MESSAGE_MAP,
  ERROR_WAGMI_MESSAGE_MAP,
  ErrorWagmiMap,
  ServerError,
} from '@constants/common/error.constants';
import { ErrorMessages } from '@constants/common/messages.constants';

export const mapWagmiError = (error: WriteContractErrorType | Error | null) => {
  if (!error) return ErrorMessages.UnknownError;

  const { message } = error;

  const errorEntries = Object.entries(ErrorWagmiMap);
  const matchedEntry = errorEntries.find(([_, value]) =>
    message.includes(value),
  );

  if (matchedEntry) {
    const [, value] = matchedEntry;
    captureException(error);
    return ERROR_WAGMI_MESSAGE_MAP[value];
  }

  captureException(error);
  return ErrorMessages.DeniedTransaction;
};

export const parseAxiosError = (error: AxiosError): ErrorMessages => {
  const serverMessage = (error.response?.data as { message?: string })
    ?.message as ServerError;
  captureException(error);

  return serverMessage
    ? ERROR_MESSAGE_MAP[serverMessage] || ErrorMessages.UnknownError
    : ErrorMessages.UnknownError;
};
